export const CYBERSECURITY_INDICATORS = {
  TITLE: 'Indicadores de Ciberseguridad',
  INDICATORS: {
    protectedDevices: 'Dispositivos Protegidos',
    managedExposedCredentials: 'Credenciales Expuestas Gestionadas',
    compliantEmployees: 'Empleados Conformes',
  },
  ON_TRACK: 'En camino',
  NEEDS_ATTENTION: 'Necesita atención',
  PROGRESS: (completed: number, total: number) => `${completed} de ${total} elementos`,
}
